(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('functionSearch', functionSearch);

    function functionSearch() {

        return {
            restrict: 'E',
            templateUrl: '/app/directives/function-search.tpl.html',
            scope: {
                onSelected: '&',
                searchPlaceholder: '='
            },
            controller: FunctionSearchController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function FunctionSearchController(portalGroupService, $translate) {
        var vm = this;
        var functions = null;

        vm.placeholder = vm.searchPlaceholder ? vm.searchPlaceholder : $translate.instant('search_functions');

        vm.onSelect = onSelect;
        vm.search = search;
        vm.clear = clear;

        function search(searchFor) {

            if (functions != null)
                return filterBySearchValue(functions, searchFor);

            return portalGroupService.getFunctions(null).then(function (results) {
                functions = _.uniq(results, 'roleId');

                return filterBySearchValue(functions, searchFor);
            });
        }

        function filterBySearchValue(items, searchFor) {
            searchFor = searchFor.toLowerCase();
            return _.filter(items, function (item) { return item.roleName.toLowerCase().indexOf(searchFor) > -1; });
        }

        function onSelect() {
            if (vm.onSelected) {
                vm.onSelected({ item: vm.selectedItem });
            }
            vm.selectedItem = null;
        }

        function clear() {
            vm.selectedItem = null;
            vm.noResults = false;
        }
    }
})();
